import React from 'react'

import { Square } from 'components/common/genericStyles'

import {
    Container,
    ArtefactWrapper,
    Participants,
    studentOverrides,
} from './styles'

import TeacherPlaceholder from '../TeacherPlaceholder'

const RoomLayoutArtefactWeb = ({ students, teacher, artefact }) => {
    return (
        <Container>
            <ArtefactWrapper>{artefact}</ArtefactWrapper>
            <Participants.Container>
                <Participants.Teacher>
                    {teacher || <TeacherPlaceholder />}
                </Participants.Teacher>
                <Participants.Students>
                    {students?.map(student => {
                        return (
                            <Square.Area
                                key={student.key}
                                $css={studentOverrides.area}
                            >
                                <Square.Wrapper $css={studentOverrides.wrapper}>
                                    {student}
                                </Square.Wrapper>
                            </Square.Area>
                        )
                    })}
                </Participants.Students>
            </Participants.Container>
        </Container>
    )
}

export default RoomLayoutArtefactWeb
